import { Navigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { useCheckPermission } from 'app/hooks/useCheckPermission'
import { useUser } from 'app/utils'

// observer: reads the staff-v2 feature toggle and authStore.user in render; both resolve
// asynchronously / change in place, so the gate needs an observer wrapper (TRK-6020).
const SettingsIndex = observer(function SettingsIndex() {
  const user = useUser()
  const checkPermission = useCheckPermission()

  if (!user) return <></>

  if (user.workspaceId) {
    const canAccessWorkspaceSettings = checkPermission(`settings:workspace`)
    if (!canAccessWorkspaceSettings) return <Navigate to={`/settings/users/${user.id}`} replace />
    return <Navigate to="/settings/workspace" replace />
  } else {
    return <Navigate to="/settings/users" replace />
  }
})

export default SettingsIndex
